export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1629_2.a2099bcd.jpg";